import React from 'react';
import c from 'classnames';
import s from './SpreadLayout.scss';

interface Props {
  className?: string;
  left?: React.ReactNode;
  right?: React.ReactNode;
}

/** A purely layout focused component that spreads `left` and `right` props horizontally via `justify-content: space-between` */
const SpreadLayout: React.FC<Props> = ({ left, right, className }) => {
  return (
    <div className={c(s['root'], className)}>
      <div className={s['left']}>{left}</div>
      <div className={s['right']}>{right}</div>
    </div>
  );
};
SpreadLayout.displayName = 'SpreadLayout';

export default SpreadLayout;
